import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../../lib/site";

const STEPS = [
    {
        num: "01",
        title: "Vous nous présentez votre besoin",
        text: "Quelques informations suffisent : type de chantier, matériel recherché, localisation et délai.",
    },
    {
        num: "02",
        title: "Un commercial vous contacte",
        text: "Un interlocuteur NEBOORZY reprend votre demande et précise avec vous les caractéristiques du projet.",
    },
    {
        num: "03",
        title: "Déplacement sur site si nécessaire",
        text: "Selon votre besoin, un commercial NEBOORZY peut se déplacer sur votre chantier ou dans votre entreprise, partout en France.",
    },
    {
        num: "04",
        title: "Proposition adaptée",
        text: "Après analyse du besoin, NEBOORZY vous présente la solution commerciale correspondante.",
    },
];

export const Process = () => (
    <section id="processus" data-testid="process-section" className="bg-paper py-24 text-ink lg:py-36">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mb-16 max-w-2xl lg:mb-24">
                <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-signal">
                    03 — Comment ça marche
                </p>
                <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
                    Un besoin ? Un commercial NEBOORZY vous accompagne partout en France.
                </h2>
            </Reveal>
            <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.12}>
                        <div data-testid={`process-step-${s.num}`} className="border-t-2 border-dashed border-zinc-300 pt-6">
                            <span className="font-mono text-5xl font-semibold text-signal">{s.num}</span>
                            <h3 className="mt-4 font-display text-lg font-bold sm:text-xl">{s.title}</h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-zinc-600">{s.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2} className="mt-16 text-center">
                <button
                    type="button"
                    data-testid="process-cta"
                    onClick={() => scrollToId("besoin")}
                    className="group inline-flex items-center gap-2 rounded-full bg-signal px-8 py-4 text-base font-bold text-ink transition-colors hover:bg-signal-dark"
                >
                    Demander une visite commerciale
                    <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
            </Reveal>
        </div>
    </section>
);
